module.exports = __webpack_public_path__ + "img/map-img-complete-sm.d3922049.webp";